module.exports = __webpack_public_path__ + "img/selected6-min.31969a34.png";